<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
     
        <b-button block v-b-toggle.privacy-section-10
          class="text-left fw-500 d-flex align-items-center justify-content-between">
              <div>
                  <span class="box-numbering">10</span>
                  <span>Contacts Us</span>    
              </div>
              <span 
                  class="toggle-icon" 
                  :class="{ active: isOpen }"
              >
                  <span class="plus">+</span>
                  <span class="cross">×</span>
              </span> 
          </b-button>

      </b-card-header>
      <b-collapse
        id="privacy-section-10"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            Contact Us If you have any questions or concerns about this Privacy
            Policy or your personal information, please contact us at:
            <ol>
                <li>{{ companyName }}</li>
                <li>Room B11, First Floor, Providence Complex,</li>
                <li>Providence, Mahe, Seychelles</li>
                <li><a href="mailto:support@oripay.us" class="fz-16">support@oripay.us</a></li>
            </ol>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "section-10",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
